import { useState } from "react";
import { ContractService } from "../../../../../core/services/ContractService";
import { Singleton } from "../../../../../core/services/Singleton";
import { InputDate } from "../../../../theme/Input/InputDate";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { PrintJson } from "../../../../theme/Component/PrintJson";

interface Props{
    ublInvoice:any;
}
export const GenerarCXP =({ublInvoice}:Props)=>{
    const single = Singleton.getInstance();
    const contracService = new ContractService();
    const [lista, setLista] = useState<any>([]);
    const [fecha,setFecha] = useState<any>(single.getCurrenDate());

   

    const createAccountantPaymentForUBLInvoice=()=>{
        single.spinner(true);
        contracService.createAccountantPaymentForUBLInvoice(ublInvoice.IDUBLInvoice,ublInvoice.IssueDate,fecha,single.getAccountID()).subscribe(
            (resp:any)=>{
               //console.log(resp);
                if(resp.DataBeanProperties.ObjectValue)
                {
                    setLista(resp.DataBeanProperties.ObjectValue);
                }
                single.spinner(false);
            }
        );
    }

    return(
        <div className="row">
            <div className="col-md-6">
                
                <label>Fecha de Registro Contable</label>
                <InputDate value={fecha} setDate={setFecha} name="fecha"/>
            </div>
            <div className="col-md-6 mt-3">
                <BasicButton icon=" ri-play-line" eventClick={createAccountantPaymentForUBLInvoice}>Generar</BasicButton>
            </div>
            <div className="col-md-12">
                <PrintJson json={lista}/>
            </div>
        </div>
    )
}